import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AttachmentComponent } from '../../../Component/Attachment/attachment/attachment.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-tax-investment-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent, NgbCollapse],
  templateUrl: './tax-investment-detail.component.html',
  styleUrl: './tax-investment-detail.component.scss'
})
export class TaxInvestmentDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  isLoad: boolean = true;
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;

  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  OpenCard = {
    CardPreviousEmployment: true as any,
    CardEmpTaxDeclarationDetails: true as any,
    CardEmpTaxDeclarationDetails_HRA: true as any,
    CardEmpTaxDeclarationDetails_Others: true as any,
    CardEmpTaxDeclarationDetails_LOP: true as any,
  }

  DetailData = {
    TransactionId: null,
    Table: [
      {
        ESS_EmpTaxInvestmentID: null,
        EmpMasterId: null,
        EmpCode: null,
        EmpName: null as any,
        IsNewRegime: null,
        FinancialYearStart: null,
        FinancialYearEnd: null,
        Photo: null,
        ApprovalStatus: null as any,
        EmpType:null
      }
    ],
    ESS_TaxPreviousEmploymentDetails: [{
      ESS_TaxPreviousEmploymentDetailsID: 0,
      ESS_EmpTaxInvestmentID: 0,
      Monthname: null,
      Yearname: null as any,
      Remarks: null,
      Basic: null as any,
      DA: null as any,
      HRA: null as any,
      OtherAllowance: null as any,
      GrossAmount: 0,
      PT: null as any,
      PF: null as any,
      TDS: null as any,
      OtherDeduction: null as any,
      NetAmount: 0,
      TimeStamp: null,
      ESS_EmpTaxInvestmentPrevEmployment_Attachment: [{
        ESS_EmpTaxInvestmentPrevEmploymentDetailsId: null,
        Attachment: null,
      }
      ],
    }],
    ESS_EmpTaxInvestmentDetails: [{
      ESS_EmpTaxInvestmentDetailsId: null,
      ESS_EmpTaxInvestmentID: null,
      ESS_TaxSectionMasterId: null,
      SectionCode: null,
      SectionName: null,
      IncomeHead: null,
      SectionDescription: null,
      ESS_TaxSectionDetailId: null,
      SubSectionName: null,
      SubSectionDescription: null,
      IsOldRegimeApplicable: true,
      IsOldMaxlimitapplicable: false,
      OldRegimeMaxAmount: 0.00,
      IsNewRegimeApplicable: true,
      IsNewMaxlimitapplicable: false,
      NewRegimeMaxAmount: 0.00,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      ESS_EmpTaxInvestmentDetails_Attachment: [{
        ESS_EmpTaxInvestmentDetailsId: null,
        Attachment: null,
      },],
    }],
    ESS_EmpTaxDeclarationDetails_HRA: [{
      ESS_EmpTaxInvestmentDetails_HRAID: null,
      ESS_EmpTaxInvestmentID: null,
      FromDate: null,
      ToDate: null,
      NameOfLandlord: null,
      LandLordPanNo: null,
      Address: null,
      IsMetroCity: null,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      ESS_EmpTaxInvestmentDetails_HRAAttachment: [{
        ESS_EmpTaxInvestmentDetails_HRAId: null,
        Attachment: null,
      }],
    }],
    ESS_EmpTaxDeclarationDetails_LOP: [{
      ESS_EmpTaxInvestmentDetails_LOPID: null,
      ESS_EmpTaxInvestmentID: null,
      AnnualRentReceived: null,
      NetAnnualValue: null,
      StandardDeduction: null,
      RepayingHomeLoanForThisProperty: null,
      PrincipalPaidOnHomeLoan: null,
      MunicipalTaxesPaid: null,
      InterestPaidOnHomeLoan: null,
      NameOfTheLender: null,
      LenderPanNo: null,
      NetIncomeLossFromHouseProperty: null,
      ESS_EmpTaxInvestmentDetails_LOPAttachment: [{
        ESS_EmpTaxInvestmentDetails_LOPId: null,
        Attachment: null,
      }]
    }],
    ESS_EmpTaxDeclarationDetails_Others: [{
      ESS_EmpTaxInvestmentDetails_OthersID: null,
      ESS_EmpTaxInvestmentID: null,
      ESS_TaxSectionDetailId: null,
      SubSectionName: null,
      SubSectionDescription: null,
      IsOldRegimeApplicable: true,
      IsOldMaxlimitapplicable: false,
      OldRegimeMaxAmount: 0.00,
      IsNewRegimeApplicable: true,
      IsNewMaxlimitapplicable: false,
      NewRegimeMaxAmount: 0.00,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      ESS_EmpTaxInvestmentDetails_OthersAttachment: []
    }],
  };

  Filter = {
    ModuleMasterId: 10,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    IsDraft: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    private incometax: IncometaxService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    //this.route.params.subscribe(params => this.Filter.IsDraft = params['draft'] == 'true' ? true : false);
    this.GetID = 2
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
    } else if (this.GetID == 2) {
      this.ESS_EmpTaxInvestmentSelect();
    }
  }

  ESS_EmpTaxInvestmentSelect() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestmentSelect({ SelectType: 'E', ESS_EmpTaxInvestmentID: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterId: this.user.UserType == 'A' ? 0 : this.user.UserId, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: this.Filter.IsDraft, ApprovalStatus: this.user.UserType == 'A' ? 'Approved' : 'ALL' }).subscribe({
      next: (response) => {
        if (response) {
          this.DetailData.Table = [];
          this.DetailData.ESS_TaxPreviousEmploymentDetails = [];
          this.DetailData.ESS_TaxPreviousEmploymentDetails = [];

          if (response.Table) {
            this.DetailData.Table = response.Table;
            this.DetailData.TransactionId = this.DetailData.Table[0].ESS_EmpTaxInvestmentID;
            this.Filter.IsDraft = response.Table[0].IsDraft;
          }

          if (response.Table3) {
            this.DetailData.ESS_TaxPreviousEmploymentDetails = response.Table3.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentPrevEmployment_Attachment: [] }));
            if (response.Table4 && response.Table4.length > 0) {
              if (response.Table4[0].ESS_EmpTaxInvestmentPrevEmploymentDetailsId != null) {
                this.DetailData.ESS_TaxPreviousEmploymentDetails.forEach(element => {
                  element.ESS_EmpTaxInvestmentPrevEmployment_Attachment = response.Table4.filter((e: any) => e.ESS_EmpTaxInvestmentPrevEmploymentDetailsId == element.ESS_TaxPreviousEmploymentDetailsID);
                });
              }
            }
          }

          if (response.Table1) {
            this.DetailData.ESS_EmpTaxInvestmentDetails = response.Table1.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_Attachment: [] }));
            if (response.Table2 && response.Table2.length > 0) {
              if (response.Table2[0].ESS_EmpTaxInvestmentDetailsId != null) {
                this.DetailData.ESS_EmpTaxInvestmentDetails.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_Attachment = response.Table2.filter((e: any) => e.ESS_EmpTaxInvestmentDetailsId == element.ESS_EmpTaxInvestmentDetailsId);
                });
              }
            }
          }

          if (response.Table5) {
            this.DetailData.ESS_EmpTaxDeclarationDetails_HRA = response.Table5.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_HRAAttachment: [] }));
            if (response.Table6 && response.Table6.length > 0) {
              if (response.Table6[0].ESS_EmpTaxInvestmentDetails_HRAId != null) {
                this.DetailData.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_HRAAttachment = response.Table6.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_HRAId == element.ESS_EmpTaxInvestmentDetails_HRAID);
                });
              }
            }
          }

          if (response.Table9) {
            this.DetailData.ESS_EmpTaxDeclarationDetails_LOP = response.Table9.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_LOPAttachment: [] }));
            if (response.Table10 && response.Table10.length > 0) {
              if (response.Table10[0].ESS_EmpTaxInvestmentDetails_LOPId != null) {
                this.DetailData.ESS_EmpTaxDeclarationDetails_LOP.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_LOPAttachment = response.Table10.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_LOPId == element.ESS_EmpTaxInvestmentDetails_LOPID);
                });
              }
            }
          }

          if (response.Table7) {
            this.DetailData.ESS_EmpTaxDeclarationDetails_Others = response.Table7.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_OthersAttachment: [] }));
            if (response.Table8 && response.Table8.length > 0) {
              if (response.Table8[0].ESS_EmpTaxInvestmentDetails_OthersId != null) {
                this.DetailData.ESS_EmpTaxDeclarationDetails_Others.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_OthersAttachment = response.Table8.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_OthersId == element.ESS_EmpTaxInvestmentDetails_OthersID);
                });
              }
            }
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.Table[0].EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.Table[0].ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Cancel() {
    if (this.user.UserType == 'A') {
      this.router.navigate(['/incometax/incometax/']);
    } else {
      this.router.navigate(['/request/incometax/taxinvestment/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  onSwitchChange(event: any, cardname: string) {
    if (cardname == "CardPreviousEmployment") {
      this.OpenCard.CardPreviousEmployment = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails") {
      this.OpenCard.CardEmpTaxDeclarationDetails = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
      this.OpenCard.CardEmpTaxDeclarationDetails_HRA = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
      this.OpenCard.CardEmpTaxDeclarationDetails_Others = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
      this.OpenCard.CardEmpTaxDeclarationDetails_LOP = event.target.checked;
    }
  }

  attachmentPopup(index: number, tabNo: number) {
    const modalRef = this.modalService.open(AttachmentComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.IsView = true;
    if (tabNo == 1 && this.DetailData.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.DetailData.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 2 && this.DetailData.ESS_EmpTaxInvestmentDetails[index].ESS_EmpTaxInvestmentDetails_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.DetailData.ESS_EmpTaxInvestmentDetails[index].ESS_EmpTaxInvestmentDetails_Attachment.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 3 && this.DetailData.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.DetailData.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 4 && this.DetailData.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.DetailData.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 5 && this.DetailData.ESS_EmpTaxDeclarationDetails_Others[index].ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.DetailData.ESS_EmpTaxDeclarationDetails_Others[index].ESS_EmpTaxInvestmentDetails_OthersAttachment.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    }

    modalRef.result.then((result: any) => { })
  }

  finalSave() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestment_InsertUpdate(
      {
        SelectType: 'FinalSave', ESS_EmpTaxInvestmentID: this.DetailData.Table[0].ESS_EmpTaxInvestmentID,
        EmpMasterId: this.user.UserId,
        ESS_TaxPreviousEmploymentDetails: [],
        ESS_EmpTaxInvestmentPrevEmployment_Attachment: [],
        ESS_EmpTaxInvestmentDetails: [],
        ESS_EmpTaxInvestmentDetails_Attachment: [],
        ESS_EmpTaxInvestmentDetails_HRA: [],
        ESS_EmpTaxInvestmentDetails_HRAAttachment: [],
        ESS_EmpTaxInvestmentDetails_LOP: [],
        ESS_EmpTaxInvestmentDetails_LOPAttachment: [],
        ESS_EmpTaxInvestmentDetails_Others: [],
        ESS_EmpTaxInvestmentDetails_OthersAttachment: [],
      }
    ).subscribe({
      next: async (response) => {
        if (response.Error_Code == '708' || response.Error_Code == '709') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            this.router.navigate(['request/incometax/taxinvestment']);
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async Delete() {
    if (this.user.UserType == 'A') {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to delete?';
      modalRef.result.then((result) => {
        if (result) {
          this.isDisabled = true;
          this.incometax.ESS_EmpTaxInvestment_InsertUpdate({ SelectType: 'AdminDelete', ESS_EmpTaxInvestmentID: this.DetailData.Table[0].ESS_EmpTaxInvestmentID, IsAdminEntry: true, }).subscribe({
            next: async (response) => {
              if (response.Error_Code == '744') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    }
  }

  GenerateTDSReport() {
    this.isDisabled = true;
    this.incometax.GenerateTDSReport({
      OperationType: 'Investment',
      Emptype: this.common.ToLowerCase(this.DetailData.Table[0].EmpType??'') == 'subcontractor'?'Front':this.DetailData.Table[0].EmpType,
      EmpmasterID: this.DetailData.Table[0].EmpMasterId,
      TaxMainID: this.DetailData.Table[0].ESS_EmpTaxInvestmentID,
      IsNewRegime: this.DetailData.Table[0].IsNewRegime,
      FinancialYearStart: new Date(this.DetailData.Table[0].FinancialYearStart??'').getFullYear(),
      FinancialYearEnd: new Date(this.DetailData.Table[0].FinancialYearEnd??'').getFullYear(),
      IsDraft: null
    }).subscribe({
      next: (response) => {
        if (response && response.ftpFileName) {
          window.open(response.ftpFileName, '_blank');
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
